<script setup>
/**
 * THE "+" — start a reservation request for this restaurant.
 *
 * One component rather than the same inline SVG copied per surface (Discover,
 * the Bookings card, the restaurant page), because it had already drifted: the
 * restaurant page drew a Vuetify icon button with an mdi glyph while every
 * other surface drew this circle (Kapil, 2026-09-22 — "make the + match how it
 * is on Discover and throughout the app").
 *
 * The root keeps the `add-btn-left` class the consumers already style, so each
 * surface's own scoped CSS still reaches it: Discover fills the circle brand
 * green, the Bookings card outlines it. The markup and the hit area are the
 * part that must not differ.
 */
defineEmits(['click'])
</script>

<template>
  <button
    type="button"
    class="add-btn-left"
    aria-label="Add to request"
    @click.stop="$emit('click', $event)"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="8"
        cy="8"
        rx="8"
        ry="8"
        fill="var(--ds-brand-primary-dark)"
      />
      <path
        d="M10.5261 7.99958H5.05243M7.78927 5.47327V10.5259"
        stroke="white"
        stroke-width="0.860438"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<style scoped>
/* Only what every surface shares; the look comes from the consumer. */
.add-btn-left {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.add-btn-left:hover {
  transform: scale(1.1);
}

.add-btn-left:active {
  transform: scale(0.95);
}
</style>
